import React, { useEffect } from 'react';

export function AdminPrivacy() {
  useEffect(() => {}, []);

  // AdminPrivacy 리턴값
  return (
    <main className="shipping wrapper">
      <div className="title">
        <h1>개인정보 수집 약관 관리</h1>
        <div className="buttons">
          <button type="button">저장</button>
        </div>
      </div>
      <div className="content">
        <h3>개인정보 수집 및 이용에 대한 안내</h3>
        <textarea name="" id="" />
      </div>
    </main>
  );
}

// 미사용 페이지
